import { defineEntityIdentity } from "../_shared/entity-identity.schemas";
import { PERMISSIONS } from "../roles-permissions/permission-catalog";

const FINANCIAL_REVIEWER_EMAILS = [
	"bkoopman@fergmar.com",
	"brobertson@fergmar.com",
	"bferguson@fergmar.com",
	"bthompson@fergmar.com",
	"cgoebel@fergmar.com"
];
const FINANCIAL_MODERATOR_EMAILS = ["cgoebel@fergmar.com"];

const financialViewerGrant = {
	...PERMISSIONS.financialReview.viewer,
	audience: "restricted" as const,
	assignByEmail: FINANCIAL_REVIEWER_EMAILS
};
const financialModeratorGrant = {
	...PERMISSIONS.financialReview.moderator,
	audience: "restricted" as const,
	assignByEmail: FINANCIAL_MODERATOR_EMAILS
};

export const companyFinancialsIdentity = defineEntityIdentity({
	definitionKey: "company-financials",
	pageKey: "companyFinancials",
	nameSingular: "companyFinancial",
	namePlural: "companyFinancials",
	relationKey: "companyFinancial",
	auditKey: "company-financials",
	storage: "durable",
	grants: {
		read: financialViewerGrant,
		create: financialModeratorGrant,
		update: financialModeratorGrant,
		delete: null
	},
	actions: {}
});

export const financialReviewTemplatesIdentity = defineEntityIdentity({
	definitionKey: "financial-review-templates",
	pageKey: "financialReviewTemplates",
	nameSingular: "financialReviewTemplate",
	namePlural: "financialReviewTemplates",
	relationKey: "financialReviewTemplate",
	auditKey: "financial-review-templates",
	storage: "durable",
	grants: {
		read: financialViewerGrant,
		create: financialModeratorGrant,
		update: financialModeratorGrant,
		delete: null
	}
});

export const finrevIssuesIdentity = defineEntityIdentity({
	definitionKey: "finrev-issues",
	pageKey: "finrevIssues",
	nameSingular: "finrevIssue",
	namePlural: "finrevIssues",
	relationKey: "finrevIssue",
	auditKey: "finrev-issues",
	storage: "durable",
	grants: {
		read: financialViewerGrant,
		create: { ...PERMISSIONS.financialReview.viewer, audience: "allMembers" },
		update: financialModeratorGrant,
		delete: null
	}
});
